import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import Button, { ButtonProps, ButtonTypeMap } from '@mui/material/Button';

export interface IBaseButtonProps extends ButtonProps {
  tooltip?: string;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  startIcon?: ButtonTypeMap['props']['startIcon'];
  endIcon?: ButtonTypeMap['props']['endIcon'];
  component?: any;
}

export default function BaseButton(
  props: IBaseButtonProps & {
    children?: React.ReactNode;
  }
) {
  const {
    startIcon,
    endIcon,
    disabled,
    className,
    color,
    variant,
    onClick,
    size,
    fullWidth,
    tooltip,
    children,
    component,
  } = props;
  const button = (
    <Button
      style={{ textTransform: 'capitalize' }}
      component={component}
      color={color}
      variant={variant}
      onClick={onClick}
      disabled={disabled}
      className={className}
      fullWidth={fullWidth}
      size={size}
      startIcon={children ? startIcon : undefined}
      endIcon={endIcon}
    >
      {children || startIcon}
    </Button>
  );

  if (tooltip) {
    return <Tooltip title={tooltip}>{button}</Tooltip>;
  }

  return button;
}
